module.exports = __webpack_public_path__ + "img/menu.26613005.svg";